import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-dark text-light pt-5 pb-3 mt-5">
      <div className="container">
        <div className="row g-4">
          {/* 1. Sütun: Firma Bilgisi */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-bold mb-3 text-warning">DMNGL Nakliyat</h5>
            <p className="small text-secondary">
              Müşterilerimiz tarafından hızlı, zamanında, güvenilir ve pratik ev eşyası paketleme ve taşıma hizmetlerimizle geniş çapta takdir edilmektedir.
            </p>
          </div>

          {/* 2. Sütun: Hızlı Bağlantılar */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-bold mb-3">Hızlı Bağlantılar</h5>
            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/" className="text-decoration-none text-secondary">Anasayfa</Link></li>
              <li className="mb-2"><Link to="/hakkimizda" className="text-decoration-none text-secondary">Hakkımızda</Link></li>
              <li className="mb-2"><Link to="/hizmetlerimiz" className="text-decoration-none text-secondary">Hizmetler</Link></li>
              <li className="mb-2"><Link to="/iletisim" className="text-decoration-none text-secondary">Bize Ulaşın</Link></li>
            </ul>
          </div>

          {/* 3. Sütun: Kurumsal */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-bold mb-3">Kurumsal</h5>
            <ul className="list-unstyled small">
              <li className="mb-2"><Link to="/blog" className="text-decoration-none text-secondary">Blog</Link></li>
              <li className="mb-2"><a href="#gizlilik" className="text-decoration-none text-secondary">Gizlilik Politikası</a></li>
            </ul>
          </div>

          {/* 4. Sütun: İletişim Bilgileri */}
          <div className="col-lg-3 col-md-6">
            <h5 className="fw-bold mb-3">İletişim</h5>
            <ul className="list-unstyled small text-secondary">
              <li className="mb-2 d-flex align-items-center gap-2">
                <FaMapMarkerAlt className="text-warning" /> İstanbul Bahçelievler
              </li>
              <li className="mb-2 d-flex align-items-center gap-2">
                <FaEnvelope className="text-warning" /> emrhn692005@gmail.com
              </li>
              <li className="mb-2 d-flex align-items-center gap-2">
                <FaPhoneAlt className="text-warning" /> +90 535 243 99 55
              </li>
              <li className="mb-2 d-flex align-items-center gap-2">
                <FaWhatsapp className="text-success" /> +90 535 243 99 55
              </li>
            </ul>
          </div>
        </div>

        <hr className="my-4 border-secondary" />

        {/* Telif Hakkı (Sosyal Medya İkonları Kaldırıldı) */}
        <div className="row">
          <div className="col-12 text-center text-secondary small">
            <p className="mb-0">&copy; {new Date().getFullYear()} DMNGL Nakliyat. Tüm Hakları Saklıdır.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;